// extracted by mini-css-extract-plugin
export default {"container":"theme_container__UYAYo","column":"theme_column__sYQes","bordered":"theme_bordered__Ro1+L"};